import {httpEndpointCustom, HttpResultSimple} from "../utils/HttpUtils";


export async function invalidatePreprava(id: number) : Promise<HttpResultSimple> {
    return await httpEndpointCustom(`admin/prepravaview/${id}/invalidate`, {method: "POST"});
}

export async function validatePreprava(id: number) : Promise<HttpResultSimple> {
    return await httpEndpointCustom(`admin/prepravaview/${id}/validate`, {method: "POST"});
}